'use strict';

export default class Homepage {
    constructor() {
        const $homeBanner = $('.home-featured-content-wp');
        const $imgSrc = $homeBanner.find('img').attr('src');
        $homeBanner.css('background-image', `url(${$imgSrc})`);


        const $leftImage = $('.field--name-field-left-column-background-ima');
        $leftImage.each(function (i, v){
            let $this = $(v);
            let $leftImgSrc = $this.find('img').attr('src');

            $this.css('background-image', `url(${$leftImgSrc})`);
        });


        const $rightImage = $('.field--name-field-right-column-background-im');
        $rightImage.each(function (i, v){
            let $this = $(v);
            let $rightImgSrc = $this.find('img').attr('src');

            $this.css('background-image', `url(${$rightImgSrc})`);
        });

        $('.-js-scroll-to-next').on('click', function (e) {
            e.preventDefault();

            $('html, body').animate({
                scrollTop: $('.home-farm-investment-loans-wp').offset().top - 72
            }, {
                duration: 1500,
                easing: 'easeInOutExpo'
            });
        });
    }
}
